import * as React from "react";
import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import { forwardRef, Ref, useRef } from "react";

interface IAppToolButtonProps extends IconButtonProps {
    tooltip?: string
    onFileClick?: (file: File) => void;
    fileInputAccept?: string;
    enableDoubleClickForOnClick?: boolean;
    icon: React.ReactNode;
}

export const AppToolButton = forwardRef((props: IAppToolButtonProps, ref: Ref<HTMLButtonElement>) => {
    const clickTimer = useRef(0);
    const inputRef = useRef<HTMLInputElement>(null);

    const clearPressTimer = () => {
        clearTimeout(clickTimer.current);
        clickTimer.current = 0;
    };
    
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (clickTimer.current) return;
        clickTimer.current = window.setTimeout(() => {
            clearPressTimer();
        }, 500);
        if (!props.onFileClick || !inputRef.current) {
            props.onClick(event);
        } else {
            inputRef.current.click();
        }
    };

    const handleFileActionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.disabled) return;
        if (!e.target.files || e.target.files.length < 1) return;
        props.onFileClick(e.target.files[0]);
    };

    const { tooltip, onFileClick, fileInputAccept, enableDoubleClickForOnClick, icon, ...iconButtonProps } = props;

    const buttonElement = <IconButton
        ref={ref} {...iconButtonProps}
        onClick={props.enableDoubleClickForOnClick ? props.onClick : handleClick}
    >
        {props.icon}
    </IconButton>;

    if (props.tooltip) {
        return (
            <Tooltip title={props.tooltip}>
                <span>
                    {buttonElement}
                    {!!props.onFileClick &&
                        <input
                            ref={inputRef}
                            type="file"
                            name="fileAppToolButton"
                            style={{ display: "none" }}
                            multiple={false}
                            accept={props.fileInputAccept}
                            onChange={handleFileActionChange}
                        />
                    }
                </span>
            </Tooltip>
        );
    }

    return (buttonElement);
});

AppToolButton.displayName = "AppToolButton";